import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Form, Input, Progress, Space, Typography, message } from "antd";
import { useState } from "react";
import { validatePassword } from "../../../../helpers/validatePassword";
import http from "../../../../services/http";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;

const passwordColors = {
  ["0"]: "#fb6a6a",
  ["50"]: "#fb6a6a",
  ["75"]: "#a8d1a8",
  ["100"]: "#60b565",
};

const rulesValidation = {
  codigo: [{ required: true, message: "Digite o código!" }],
  senha: [{ required: true, message: "Digite a nova senha!" }],
  senha_confirmation: [{ required: true, message: "Digite novamente a senha!" }],
};

const FormRecuperacaoSenha = ({ matricula, onBackPress }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [passStrength, setPassStrength] = useState(0);

  // ALTERAR SENHA
  const alterarSenha = async (form) => {
    if (!matricula) return;
    setLoading(true);
    form.matricula = matricula;
    const api = await http("post", "v1/autenticacao/recuperar_senha", form);
    if (api.statusCode === 200) {
      setLoading(false);
      navigate("/recuperacao-senha-sucesso");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // FINALIZAR FORMULÁRIO
  const onSubmit = (values) => {
    if (values.senha !== values.senha_confirmation) {
      form.setFields([
        {
          name: "senha_confirmation",
          errors: ["As senhas não conferem!"],
        },
      ]);
    } else if (validatePassword(values.senha) !== 100) {
      form.setFields([
        {
          name: "senha",
          errors: ["Senha muito fraca!"],
        },
      ]);
    } else {
      alterarSenha(values);
    }
  };

  // VERIFICAR FORÇA DA SENHA
  const checkPassword = (field) => {
    setPassStrength(validatePassword(field.target.value) ?? 0);
  };

  return (
    <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
      <Form.Item name="codigo" label="Código" rules={rulesValidation.codigo}>
        <Input size="large" disabled={loading} placeholder="Informe o código" />
      </Form.Item>

      <Form.Item label="Nova Senha" name="senha" rules={rulesValidation.senha}>
        <Input.Password
          size="large"
          onChange={checkPassword}
          className="input"
          prefix={<LockOutlined className="site-form-item-icon" />}
          placeholder="Digite a nova senha"
          iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
          disabled={loading}
        />
      </Form.Item>

      <Progress
        percent={passStrength}
        size="small"
        showInfo={false}
        strokeColor={passwordColors[passStrength]}
        status="exception"
      />

      <Space direction="vertical" size={2}>
        <Text type="secondary">Sua senha deve ter:</Text>
        <Text type="secondary" italic>
          <ul>
            <li>Mínimo de 8 characteres de tamanho.</li>
            <li>Pelo menos 1 letra em maiúsculo. (A,B...).</li>
            <li>Pelo menos 1 letra em minúsculo. (a,b...).</li>
            <li>Pelo menos 1 número. (1,2,3...9).</li>
          </ul>
        </Text>
      </Space>

      <Form.Item label="Repetir Senha" name="senha_confirmation" rules={rulesValidation.senha_confirmation}>
        <Input.Password
          size="large"
          className="input"
          prefix={<LockOutlined className="site-form-item-icon" />}
          placeholder="Digite novamente a senha"
          iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
          disabled={loading}
        />
      </Form.Item>

      <Form.Item className="FormItem">
        <Button block size="large" loading={loading} type="primary" htmlType="submit">
          Enviar
        </Button>
      </Form.Item>

      <Form.Item className="FormItem">
        <Button block size="large" onClick={onBackPress} icon={<ArrowLeftOutlined />} loading={loading} type="text">
          Voltar
        </Button>
      </Form.Item>
    </Form>
  );
};

export { FormRecuperacaoSenha };
